import { Component, OnInit, Input } from '@angular/core';
import { AccordionComponent } from '../accordion/accordion.component';
import { AccordionItemComponent } from '../accordion/accordion-item.component';
import { PaymentInfoMessageComponent } from './payment-info-message/payment-info-message.component';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.sass'],
  standalone: true,
  imports: [AccordionComponent, AccordionItemComponent, PaymentInfoMessageComponent]
})
export class PaymentInfoComponent implements OnInit {
  @Input() paymentInfoMessages!: string;
  constructor() { }

  ngOnInit(): void {
  }
}
